import React, { useContext, useRef, useState } from 'react'
import './Reportscontains.css'
import milkcan from "../../imgs/bill.png";
import khate from "../../imgs/khate.webp";
import sanklan from "../../imgs/sanklanreport.png";
import khadya from "../../imgs/khadya.png";
import pregister from "../../imgs/pregister.png";
import retan from "../../imgs/retan.png";
import bank from "../../imgs/bank.png";
import milkvan from "../../imgs/milkvan.png";

import Box from '../Box/Box';
import Cowleft from "../../imgs/cowleft.gif";
import { useNavigate } from 'react-router-dom';
import Dialog from '../Dialog/Dialog';
import Globalcontext from '../../Context/Globalcontext';

import Bill from '../Bill/Bill';
import Pregister from '../Pregister/Pregister';
import Bankreport from '../Bankreport/Bankreport';
import Pregistervar from '../Pregistervar/Pregistervar';
import Customerreport from '../Customerreport/Customerreport';
import Customerreportvar from '../Customerreportvar/Customerreportvar';
import Sanklanreport from '../Sanklanreport/Sanklanreport';
import Khadyaadvreport from '../Khadyaadvreport/Khadyaadvreport';
import Vikrireport from '../Vikrireport/Vikrireport';
import Billvar from '../Billvar/Billvar';
import Itrreports from '../Itrreports/Itrreports';

import { useTranslation } from "react-i18next";

const Reportscontains = (props) => {
    const [mastermenu, setMastermenu] = useState(true);
    const [showBackImage, setShowBackImage] = useState(false);
    const [transitionEnded, setTransitionEnded] = useState(true);
    const [kopen, setkopen] = useState(0);

    const { submenu, setsubmenu } = useContext(Globalcontext);
    const { setHeadname } = useContext(Globalcontext);

    const navigate = useNavigate();
    const [dialog, setDialog] = useState({
        message: "",
        isLoading: false,
        nameProduct: ""
    });

    const [t] = useTranslation();

    const areUSure = () => {
        handleDialog("", false);
    };

    const openkendra = () => {
        setShowBackImage(true);
        setMastermenu(false);
        setTransitionEnded(true);
        setsubmenu("kendra");
        setkopen(1);
    }

    const handleDialog = (message, isLoading, nameProduct) => {
        setDialog({ message, isLoading, nameProduct });
    };

    const visibility = () => {
        localStorage.setItem("glcustsr", "");
        setTransitionEnded(false);
        setMastermenu(!mastermenu);
        setkopen(0);
        setsubmenu("");
        setHeadname(t("head.reports"));
    }

    const handleTransitionEnd = () => {
        if (!mastermenu) setShowBackImage(true);
        else setShowBackImage(false);
        setTransitionEnded(true);
    };

    return (
        <>
            <div className='line' />
            <div className="maincon">

                <div className="rowreport">
                    <div className="mainconreport">
                        <span className={`heading1 ${mastermenu ? '' : 'hidden'}`}>
                            {t("reports.ten_day_title")}
                        </span>

                        <div className={`Dashcontents ${mastermenu ? '' : 'hidden'}`} onTransitionEnd={handleTransitionEnd}>
                            <Box
                                action="bill"
                                setsubmenu={setsubmenu}
                                visibility={visibility}
                                background={"linear-gradient(179deg, var(--t4dark), var(--t4dark))"}
                                head={t("reports.boxes.bill")}
                                img={<img src={milkcan} alt="" />}
                            />
                            <Box
                                action="pregister"
                                setsubmenu={setsubmenu}
                                visibility={visibility}
                                background={"linear-gradient(179deg, var(--t6dark), var(--t6dark))"}
                                head={t("reports.boxes.payment_register")}
                                img={<img src={pregister} alt="" />}
                            />
                        </div>
                    </div>

                    <div className="mainconreport2">
                        <span className={`heading1 ${mastermenu ? '' : 'hidden'}`}>
                            {t("reports.other_title")}
                        </span>

                        <div className={`Dashcontents ${mastermenu ? '' : 'hidden'}`} onTransitionEnd={handleTransitionEnd}>
                            <Box
                                action="bankreport"
                                setsubmenu={setsubmenu}
                                visibility={visibility}
                                background={"linear-gradient(179deg, var(--t4dark), var(--t4dark))"}
                                head={t("reports.boxes.bank_payment_report")}
                                img={<img src={bank} alt="" />}
                            />

                            <Box
                                action="account"
                                setsubmenu={setsubmenu}
                                visibility={visibility}
                                background={"linear-gradient(179deg, var(--t1dark), var(--t1dark))"}
                                head={t("reports.boxes.member_account")}
                                img={<img src={khate} alt="" />}
                            />

                            <Box
                                action="sanklanreport"
                                setsubmenu={setsubmenu}
                                visibility={visibility}
                                background={"linear-gradient(179deg, var(--t2dark), var(--t2dark))"}
                                head={t("reports.boxes.sanklan_report")}
                                img={<img src={sanklan} alt="" />}
                            />

                            <Box
                                action="vikrireport"
                                setsubmenu={setsubmenu}
                                visibility={visibility}
                                background={"linear-gradient(179deg, var(--t2dark), var(--t2dark))"}
                                head={t("reports.boxes.sangh_ratib_report")}
                                img={<img src={milkvan} alt="" />}
                            />

                            <Box
                                action="khadyaadvreport"
                                setsubmenu={setsubmenu}
                                visibility={visibility}
                                background={"linear-gradient(179deg, var(--t3dark), var(--t3dark))"}
                                head={t("reports.boxes.khadya_advance_report")}
                                img={<img src={khadya} alt="" />}
                            />

                            <Box
                                action="itrreports"
                                setsubmenu={setsubmenu}
                                visibility={visibility}
                                background={"linear-gradient(179deg, var(--t5dark), var(--t5dark))"}
                                head={t("reports.boxes.other_reports")}
                                img={<img src={retan} alt="" />}
                            />
                        </div>
                    </div>
                </div>

                <div className={`rowbox ${mastermenu ? '' : 'hidden'}`}>
                    <div className="first"></div>
                    <div className="second">
                        <div className='line70' />
                        <span className='firstspan'>{t("reports.info.1")}</span>
                        <span className='infospan'>{t("reports.info.2")}</span>
                        <span className='infospan'>{t("reports.info.3")}</span>
                    </div>
                </div>

                <div className={`cust ${mastermenu ? 'hidden' : ''}`}>
                    {transitionEnded && showBackImage && (
                        submenu === "bill"
                            ? (localStorage.getItem("bill10type") === "1"
                                ? <Bill setProgress={props.setProgress} visibility={visibility} handleTransitionEnd={handleTransitionEnd} setTransitionEnded={setTransitionEnded} />
                                : localStorage.getItem("bill10type") === "0"
                                    ? <Billvar setProgress={props.setProgress} visibility={visibility} handleTransitionEnd={handleTransitionEnd} setTransitionEnded={setTransitionEnded} />
                                    : ""
                            )
                            : submenu === "pregister"
                                ? (localStorage.getItem("bill10type") === "1"
                                    ? <Pregister setProgress={props.setProgress} visibility={visibility} handleTransitionEnd={handleTransitionEnd} setTransitionEnded={setTransitionEnded} />
                                    : localStorage.getItem("bill10type") === "0"
                                        ? <Pregistervar setProgress={props.setProgress} visibility={visibility} handleTransitionEnd={handleTransitionEnd} setTransitionEnded={setTransitionEnded} />
                                        : ""
                                )
                                : submenu === "bankreport"
                                    ? <Bankreport setProgress={props.setProgress} visibility={visibility} handleTransitionEnd={handleTransitionEnd} setTransitionEnded={setTransitionEnded} />
                                    : submenu === "account"
                                        ? (localStorage.getItem("bill10type") === "1"
                                            ? <Customerreport setProgress={props.setProgress} visibility={visibility} handleTransitionEnd={handleTransitionEnd} setTransitionEnded={setTransitionEnded} />
                                            : localStorage.getItem("bill10type") === "0"
                                                ? <Customerreportvar setProgress={props.setProgress} visibility={visibility} handleTransitionEnd={handleTransitionEnd} setTransitionEnded={setTransitionEnded} />
                                                : ""
                                        )
                                        : submenu === "sanklanreport"
                                            ? <Sanklanreport setProgress={props.setProgress} visibility={visibility} handleTransitionEnd={handleTransitionEnd} setTransitionEnded={setTransitionEnded} />
                                            : submenu === "vikrireport"
                                                ? <Vikrireport setProgress={props.setProgress} visibility={visibility} handleTransitionEnd={handleTransitionEnd} setTransitionEnded={setTransitionEnded} />
                                                : submenu === "khadyaadvreport"
                                                    ? <Khadyaadvreport setProgress={props.setProgress} visibility={visibility} handleTransitionEnd={handleTransitionEnd} setTransitionEnded={setTransitionEnded} />
                                                    : submenu === "itrreports"
                                                        ? <Itrreports setProgress={props.setProgress} visibility={visibility} handleTransitionEnd={handleTransitionEnd} setTransitionEnded={setTransitionEnded} />
                                                        : ""
                    )}
                </div>
            </div>

            <div className="secrow">
                <div className="leftsecrow"></div>
                {
                    submenu !== "sanklan" &&
                    submenu !== "bill" &&
                    submenu !== "pregister" &&
                    submenu !== "account" &&
                    submenu !== "sanklanreport" &&
                    submenu !== "khadyaadvreport" &&
                    submenu !== "vikrireport" &&
                    submenu !== "bankreport" &&
                    submenu !== "itrreports"
                        ? (
                            <div className="imgcon">
                                <img className='imgcowtran' src={Cowleft} alt="" />
                            </div>
                        )
                        : ""
                }
            </div>

            {dialog.isLoading && (
                <Dialog
                    submessage={dialog.nameProduct}
                    onDialog={areUSure}
                    message={dialog.message}
                    functionname={openkendra}
                    button1text={t("dialog.no")}
                    button2text={t("dialog.yes")}
                />
            )}
        </>
    )
}

export default Reportscontains
